module.exports = __webpack_public_path__ + "img/playstore.38030101.png";